module.exports = "<wc-popover :placement=\"popoverPlacement\" :trigger=\"popoverTrigger\" :className=\"'wc-tooltip'\" >\n  <slot></slot>\n  <div slot=\"popContent\">\n    {{title}}\n  </div>\n</wc-popover>"


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/src/wc-ui/components/tooltip/tooltip.html
// module id = 996
// module chunks = 0